import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://snfmmaneibrjjymzokca.supabase.co";
const SUPABASE_KEY =
	"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNuZm1tYW5laWJyamp5bXpva2NhIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTAyMzI3NzIsImV4cCI6MjAwNTgwODc3Mn0.4ky2GVon5VVFfuu8VjR-wYVPt4B6orWpqTIaSGrlzbc";

const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

export default supabase;
